module.exports = __webpack_public_path__ + "img/default-user.9c0032fb.png";